// Counts of a client as read with an override row (GET /collections/{id}/client-overrides) or an access target
// of the collection list: `platformCount`, `subClientCount` and `subClientsPlatformCount`.

export const isParent = (client) => client.subClientCount > 0;

// Platforms a client row reaches: those of the client, plus those of its sub-clients for a parent.
export const reachedPlatformCount = (client) => client.platformCount + (isParent(client) ? client.subClientsPlatformCount : 0);

// Data of the counts line of a client: its reference and its platforms, or for a parent, which shows no
// reference, its sub-clients and every platform it reaches.
export const clientCounts = (client) => ({
    reference: isParent(client) ? null : (client.reference ?? null),
    platformCount: reachedPlatformCount(client),
    subClientCount: client.subClientCount,
});

// Counts line of a client, from its clientCounts: "REF · 1 platform", or "2 sub-clients · 3 platforms" for a parent.
export const countsLine = (t, { reference, platformCount, subClientCount }) =>
    [
        reference,
        subClientCount > 0 && t('{{count}} sub-client(s)', { count: subClientCount }),
        t('{{count}} platform(s)', { count: platformCount }),
    ]
        .filter(Boolean)
        .join(' · ');
